import { render, staticRenderFns } from "./LeaveTypes.vue?vue&type=template&id=a77bc422&"
import script from "./LeaveTypes.vue?vue&type=script&lang=ts&"
export * from "./LeaveTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports